import {
  fontSize,
  minBreakpoints,
  responsiveFontSize,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, shadowUp, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text, fonts } = theme;

export const noSearchResultsWrapper = css`
  text-align: center;
  padding-top: ${pxToRem(spacing.xxxxl)};
  margin: ${stack(spacing.xl)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${shadowUp};
    `,
  )};
`;

export const heading = css``;

export const headingText = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${fontSize(text.BODY.MD)}
  color: var(--neutral-black-70);
  display: block;
`;

export const headingTerm = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${responsiveFontSize({
    XXS: text.HEADING.LG,
    L: text.HEADING.XL,
  })};
  display: block;
`;

export const info = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  font-size: ${text.BODY.MD.fontSize}px;
  margin-top: ${pxToRem(spacing.xxxl)};
`;
